<template>
<div class="chapter">
<div class="inner_page">
<p class="P-P" id="calibre_pb_0"> </p>
<p class="P-P1"> </p>
<p class="P-P2">WHY</p>
<p class="P-P2">AREN'T YOU SWEET</p>
<p class="P-P2">LIKE ME ??</p>
<p class="P-P3"> </p>
<p class="P-P4"> </p>
<p class="P-P4"> </p>
<p class="P-P4"> </p>
<p class="P-P5">Carrie Nyman</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?59699af2